import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { useAccountingSoftwareName } from 'src/core/modules/accounting-integration/apis';
import { type AnalyticalFieldExportSettings } from 'src/core/modules/accounting-integration/apis/useAnalyticalFieldExportSettings';
import { type SyncMode } from 'src/core/modules/accounting-integration/apis/useSetSyncSettings';
import { AnalyticalFieldSelector } from 'src/core/modules/accounting-integration/components/AnalyticalFieldMapping/AnalyticalFieldSelector';
import { ExportSettings } from 'src/core/modules/accounting-integration/components/ExportSettings/ExportSettings';
import { type AnalyticalFieldMappingV2 } from 'src/core/modules/bookkeep';

type Props = {
  analyticalFieldMappings: AnalyticalFieldMappingV2[];
  onChange: (field: AnalyticalFieldMappingV2 | undefined) => void;
  fieldMapping: AnalyticalFieldMappingV2 | undefined;
  syncMode?: SyncMode;
  exportSettings: AnalyticalFieldExportSettings | undefined;
  onExportSettingsChange: (settings: AnalyticalFieldExportSettings) => void;
  isSplittable: boolean;
  fieldName?: string;
};

export const EcFormModalContentPullMode = ({
  onChange,
  analyticalFieldMappings,
  fieldMapping,
  syncMode,
  exportSettings,
  isSplittable,
  onExportSettingsChange,
  fieldName,
}: Props) => {
  const { t } = useTranslation('global');
  const { integration } = useAccountingSoftwareName();

  return (
    <div className="mt-24">
      <AnalyticalFieldSelector
        fieldMapping={fieldMapping}
        fieldName={
          fieldName ??
          t('accounting-integration.exportSettings.fieldTypes.expenseCategory')
        }
        fields={analyticalFieldMappings}
        onValueSelected={onChange}
      />

      {integration === 'Netsuite' && (
        <div className="mt-24">
          <ExportSettings
            fieldType="expenseCategory"
            value={exportSettings}
            isSplittable={isSplittable}
            fieldName={
              fieldName ?? t('expenseCategories.requestPanel.expenseCategory')
            }
            externalField={
              fieldMapping
                ? {
                    id: fieldMapping.externalId,
                    name: fieldMapping.externalName,
                  }
                : undefined
            }
            variant="secondary"
            syncMode={syncMode}
            onChange={(settings) => {
              if (fieldMapping) {
                onExportSettingsChange(settings);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};
